const batchActionTypes = {
  Relocate: 'Relocalisation',
  Stuff: 'Remplissage',
  Transfer: 'Transfert',
  Unstuff: 'Vidage',
  Unseal: 'Descellé',
  Move: 'Déplacement',
  ResolveMissingItem: "Résolution d'item manquant",
};

export default batchActionTypes;
